import { SkeletonRect } from "./skeleton-rect";
import { SkeletonLine } from "./skeleton-line";
import { SkeletonCircle } from "./skeleton-circle";

export const Skeleton = {
  Rect: SkeletonRect,
  Line: SkeletonLine,
  Circle: SkeletonCircle,
};
